(() => {
  'use strict';

  if (window.SMIBStandaloneNotifyLoaded) return;
  window.SMIBStandaloneNotifyLoaded = true;

  const PRODUCT_SELECT_EVENT = 'shopify:product:select';

  function getPopup(trigger) {
    const id = trigger?.getAttribute('data-smib-notify-open');
    return id ? document.getElementById(id) : null;
  }

  function openPopup(trigger) {
    const popup = getPopup(trigger);
    if (!(popup instanceof HTMLElement)) return;
    popup.hidden = false;
    trigger.setAttribute('aria-expanded', 'true');
    const input = popup.querySelector('[data-smib-notify-email]');
    if (input instanceof HTMLInputElement) requestAnimationFrame(() => input.focus());
  }

  function closePopup(popup) {
    if (!(popup instanceof HTMLElement)) return;
    popup.hidden = true;
    const trigger = document.querySelector(`[data-smib-notify-open="${CSS.escape(popup.id)}"]`);
    if (trigger instanceof HTMLElement) trigger.setAttribute('aria-expanded', 'false');
  }

  function hiddenInput(form, name, value) {
    const input = document.createElement('input');
    input.type = 'hidden';
    input.name = name;
    input.value = value;
    form.appendChild(input);
  }

  function submit(wrapper, popup) {
    const email = popup.querySelector('[data-smib-notify-email]');
    const message = popup.querySelector('[data-smib-notify-message]');
    const submitButton = popup.querySelector('[data-smib-notify-submit]');
    if (!(email instanceof HTMLInputElement) || !(submitButton instanceof HTMLButtonElement)) return;

    const value = email.value.trim();
    if (!value || !email.checkValidity()) {
      if (message) message.textContent = 'Enter a valid email address.';
      email.reportValidity();
      return;
    }

    const productTitle = wrapper.dataset.productTitle || '';
    const variantId = wrapper.dataset.variantId || '';
    const variantTitle = wrapper.dataset.variantTitle || '';
    const baseUrl = wrapper.dataset.productUrl || '';
    const productUrl = variantId ? `${baseUrl}?variant=${encodeURIComponent(variantId)}` : baseUrl;

    const form = document.createElement('form');
    form.method = 'post';
    form.action = '/contact#smib-notify-request';
    form.hidden = true;

    hiddenInput(form, 'form_type', 'contact');
    hiddenInput(form, 'utf8', '✓');
    hiddenInput(form, 'contact[email]', value);
    hiddenInput(form, 'contact[subject]', `Notify me: ${productTitle} ${variantTitle}`);
    hiddenInput(
      form,
      'contact[body]',
      `NOTIFY ME REQUEST\n\nProduct: ${productTitle}\nSize or variant: ${variantTitle}\nVariant ID: ${variantId}\nProduct URL: ${productUrl}\nCustomer email: ${value}`
    );

    document.body.appendChild(form);
    form.submit();
  }

  document.addEventListener(PRODUCT_SELECT_EVENT, (event) => {
    const productId = String(event.product?.id || '');
    if (!productId || !event.promise) return;

    const source = event.target instanceof Element ? event.target : null;
    const root = source?.closest('.shopify-section, dialog, product-card') || document;

    event.promise
      .then(({ detail }) => {
        const variant = detail?.resource || null;
        root.querySelectorAll('[data-smib-notify-wrapper]').forEach((wrapper) => {
          if (!(wrapper instanceof HTMLElement)) return;
          if (wrapper.dataset.productId !== productId) return;

          const soldOut = Boolean(variant && variant.id && variant.available === false);
          wrapper.hidden = !soldOut;

          if (soldOut) {
            wrapper.dataset.variantId = String(variant.id || '');
            wrapper.dataset.variantTitle = String(variant.title || variant.name || '');
            const label = wrapper.querySelector('[data-smib-notify-variant-label]');
            if (label) label.textContent = wrapper.dataset.variantTitle;
          } else {
            const popup = wrapper.querySelector('[data-smib-notify-popup]');
            if (popup instanceof HTMLElement) closePopup(popup);
          }
        });
      })
      .catch(() => {});
  });

  document.addEventListener('click', (event) => {
    if (!(event.target instanceof Element)) return;

    const trigger = event.target.closest('[data-smib-notify-open]');
    if (trigger instanceof HTMLButtonElement) {
      event.preventDefault();
      event.stopPropagation();
      openPopup(trigger);
      return;
    }

    const close = event.target.closest('[data-smib-notify-close]');
    if (close) {
      const popup = close.closest('[data-smib-notify-popup]');
      if (popup instanceof HTMLElement) closePopup(popup);
      return;
    }

    const submitButton = event.target.closest('[data-smib-notify-submit]');
    if (submitButton) {
      const popup = submitButton.closest('[data-smib-notify-popup]');
      const wrapper = submitButton.closest('[data-smib-notify-wrapper]');
      if (popup instanceof HTMLElement && wrapper instanceof HTMLElement) submit(wrapper, popup);
    }
  });

  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;
    const popup = document.querySelector('[data-smib-notify-popup]:not([hidden])');
    if (popup instanceof HTMLElement) closePopup(popup);
  });
})();
